import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var GlobalRichText = function GlobalRichText() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalRichText.vue');
};

var RATIOS = {
  '16:9': 'ri-16_9',
  '4:3': 'ri-4_3',
  '1:1': ''
};
export default {
  name: 'CollectionStyle',
  components: {
    GlobalRichText: GlobalRichText
  },
  props: {
    url: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    ratio: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true
    },
    title: {
      type: Array,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    builderRatio: function builderRatio() {
      return RATIOS[this.ratio];
    }
  }
};